import { IFormData } from 'common-tridium/ui';
import { Vehicle as VehicleEsUC } from 'markets/toyota/usedCars/es/models/es-vehicle.model';
import { Vehicle as VehicleFrUC } from 'markets/toyota/usedCars/fr/models/fr-vehicle.model';
import { Vehicle as VehicleRuUC } from 'markets/toyota/usedCars/ru/models/ru-vehicle.model';
import { Vehicle as VehicleFiUC } from 'open-api-generator/toyota/usedCars/fi/models';

export type IGenericVehicleUC = VehicleEsUC | VehicleFrUC | VehicleRuUC | VehicleFiUC;

export interface IGenericEmailRequestProps {
  car?: object;
  formData: IFormData;
}

export type TMarketContainerStateType = {
  isLoadingI18N: boolean;
  dependenciesLoaded: boolean;
  dependenciesError: boolean;
  errorStatus: number;
  isLoading: boolean;
};

export interface IMarketConfigParams {
  country?: string;
  language?: string;
  vehicle?: object;
}

export enum ThemeEnum {
  bz = 'bz',
  speedboat = 'speedboat',
  default = '',
}
